import React, { useState, useEffect} from "react";
import { Redirect } from 'react-router-dom'
import {
    TableRow,
} from '@material-ui/core';
import 'moment/min/locales';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles.js';
import Loading from '../ui/Loading.js';
import { useIntl } from "react-intl";
import swal from 'sweetalert'
import * as Utils from '../../commons/utils/Utils'


const ConfigPeriodosPresupuestariosGridRow = ({config, loading, baseUrl}) => {
  const intl = useIntl()
  const [estaEnCurso, setEstaEnCurso] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)
  const [duracionLabel, setDuracionLabel] = useState('')

  const duraciones = [
    { value: 1, label: `1 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Mes", defaultMessage: "Mes" })}` },
    { value: 3, label: `3 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Meses", defaultMessage: "Meses" })}` },
    { value: 6, label: `6 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Meses", defaultMessage: "Meses" })}` },
    { value: 12, label: `1 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Año", defaultMessage: "Año" })}` },
    { value: 24, label: `2 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage: "Años" })}` },
    { value: 36, label: `3 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage: "Años" })}` },
    { value: 48, label: `4 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage: "Años" })}` },
    { value: 60, label: `5 ${intl.formatMessage({ id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage: "Años" })}` }
  ];

  const handleDelete = () => {
    
            if (estaEnCurso === true) {
                swal("No se puede eliminar", "El periodo ya está en curso y no puede ser eliminado.", "warning");
                return;
            } else {
              swal({
                title: '¿Confirma la eliminación?' ,
                text: null,
                icon: "warning",
                buttons: {
                    confirm: {
                        text: 'Si' ,
                        value: true,
                        visible: true,
                        className: "btn btn-primary",
                        closeModal: false
                    },
                    cancel: {
                        text:  'No' ,
                        value: null,
                        visible: true,
                        className: "btn btn-danger",
                        closeModal: true,
                    }
                }
            })
            .then((isConfirm) => {
                if (isConfirm) {
                      Utils.deleteData('/periodo-configs/' + config.id)
                      .then((response) => {
                        if (response) {
                          swal("Eliminado", "La configuración ha sido eliminada con éxito.", "success").then(() => {
                            window.location.reload();
                          });
                        } else {
                          swal("Error", "No se pudo eliminar la configuración.", "error");
                        }
                      })
                      .catch(() => {
                        swal("Error", "Ocurrió un error al intentar eliminar la configuración.", "error");
                      });
                }
            });
            }
  };

  const handleEditar = () => {
    if (estaEnCurso) {
        swal("No se puede editar", "El periodo ya está en curso y no puede ser editado.", "warning");
        return;
    } else {
        setRedirectTo(baseUrl + '/' + config.id + '/edit');
    }
  }

useEffect(() => {
  setDuracionLabel(duraciones.find(d => d.value === config.duracion).label || config.duracion);
  Utils.getData('/periodo-configs/validarInicio/' + config.id)
  .then((response) => {
      setEstaEnCurso(response);
  })
  .catch(() => {
      swal("Error", "Ocurrió un error al validar el estado del periodo.", "error");
  });
}, [config.id]);

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      {loading && <Loading />}
      <TableRow>
          <StyledTableCell align="left">
            {config.nombre}
          </StyledTableCell>
          <StyledTableCell align="left">
            {config.frecuencia}
          </StyledTableCell>
          <StyledTableCell align="left">
          {duracionLabel}
          </StyledTableCell>
          <StyledTableCell align="left">
          {config.fecha_inicio}
          </StyledTableCell>
          <StyledTableCell>
          <div className="d-inline-flex">
              <button
                className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                title="Ver"
                data-togle="tooltip"
                data-placement="top"
                onClick={() => setRedirectTo(baseUrl + '/' + config.id)}
              >
                <i className="fa fa-search fa-xs"/>
              </button>
              <button
                className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                title="Editar"
                data-togle="tooltip"
                data-placement="top"
                onClick={handleEditar}
                >
                  <i className="fa fa-pencil fa-xs"/>
              </button>
              <button
                className="action delete btn btn-sm btn-icon btn-dt-grid text-danger"
                title="Eliminar"
                data-togle="tooltip"
                data-placement="top"
                onClick={handleDelete}
                >
                  <i className="fa fa-trash fa-xs"/>
              </button>
          </div>
        </StyledTableCell>
      </TableRow>
      </>
  )
}


export default ConfigPeriodosPresupuestariosGridRow;